import { useChat } from '@/features/ai-chat/state/useChat';

export function useNoMessagesScreen() {
  const { sendMessage } = useChat();
  return { sendMessage } as const;
}
